import { useEffect } from 'react';

/**
 * Renders search-engine verification <meta> tags into <head>, but only when
 * a non-empty value is provided via env vars. Never injects placeholder/fake
 * tokens.
 *
 * Set the values in /app/frontend/.env when you receive them:
 *   REACT_APP_GOOGLE_SITE_VERIFICATION=...   (from Google Search Console)
 *   REACT_APP_BING_SITE_VERIFICATION=...     (from Bing Webmaster Tools)
 *
 * The component does NOT create the tags when the env var is missing or
 * blank — that way an unverified site never ships fake tokens.
 */
export const SiteVerification = () => {
  useEffect(() => {
    const google = (process.env.REACT_APP_GOOGLE_SITE_VERIFICATION || '').trim();
    const bing = (process.env.REACT_APP_BING_SITE_VERIFICATION || '').trim();

    const upsert = (id, name, content) => {
      let el = document.getElementById(id);
      if (!content) {
        if (el) el.remove();
        return null;
      }
      if (!el) {
        el = document.createElement('meta');
        el.id = id;
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
      return el;
    };

    upsert('meta-google-site-verification', 'google-site-verification', google);
    upsert('meta-bing-site-verification', 'msvalidate.01', bing);
  }, []);

  return null;
};

export default SiteVerification;
